module.exports = __webpack_public_path__ + "static/Syberia5-022904bd2c95505bbcc7d909443cc693.png";